<template>
    <div >

       <a v-if="cdrFileLinkProp" title="Image-set CDR" :href="cdrFileLinkProp" download class="btn btn-success btn-xs" target="_blank">
         <b-icon icon="download" aria-hidden="true" ></b-icon>  CDR
       </a>
        <a v-if="imageGridLinkProp" title="Image-set JPEG" :href="imageGridLinkProp" download class="btn btn-primary btn-xs m-l-5" target="_blank">
         <b-icon icon="download" aria-hidden="true" ></b-icon> JPEG
       </a>

       
       
       <b-btn variant="default" :class="{active: showFileInput}" size="xs" @click="showUpdateFiles"><b-icon icon="gear-fill" aria-hidden="true" ></b-icon> Update Files</b-btn>

      <transition name="fade">
        <div class="m-t-20" v-if="showFileInput">
            <b-form-group>
              <label for="">Image-set Coral Draw File</label>
              <b-form-input v-model="cdrFileLink" placeholder="Enter coral file link" @change="setFile('cdrFileLink')"></b-form-input>

              <div class="m-t-10">
                <presigned-upload v-model="cdrFile" heading="Upload CDR File"/>
              </div>

            </b-form-group>
            <b-form-group>
              <label for="">Image-set JPEG File</label>
              <b-form-input v-model="imageGridLink" placeholder="Enter jpeg file link" @change="setFile('imageGridLink')"></b-form-input>

              <div class="m-t-10">
                <presigned-upload v-model="imageFile" heading="Upload Image-set JPEG File"/>
              </div>
            </b-form-group>
        </div>
      </transition>


    </div>
</template>

<script>
import ItemListService from '../../services/item-list.service'
const PresignedUpload = () => import(/* webpackChunkName: "presigned-upload" */ '../../components/common/presigned-upload')
import EventBus from '../../EventBus'
  export default {
    props: {
      itemId: {
        type: Number,
        default: null
      },
      cdrFileLinkProp: {
        type: String,
        default: ''
      },
      imageGridLinkProp: {
        type: String,
        default: ''
      },

    },
    components: {PresignedUpload},
    data(){
      return {
        showFileInput: false,
        cdrFileLink: this.cdrFileLinkProp,
        imageGridLink: this.imageGridLinkProp,
        cdrFile: null,
        imageFile: null
      }
    },
    watch:{
      cdrFileLinkProp(newValue){
         this.cdrFileLink= newValue;
      },
      imageGridLinkProp(newValue){
         this.imageGridLink= newValue;
      },
      cdrFile(newValue){
         this.cdrFileLink= newValue;
         this.setFile('cdrFileLink')
      },
      imageFile(newValue){
         this.imageGridLink= newValue;
         this.setFile('imageGridLink')
      },
    },
    methods: {
      showUpdateFiles(){
        this.showFileInput = !this.showFileInput
      },
      async setFile(fileType){
          try{
              let data = {
                value: this[fileType],
                field: fileType
              }
              const result = await ItemListService.setSingleValue(data, this.itemId);
              EventBus.$emit('item-in-list-updated', {id: this.itemId, theItem: result.data.theItem})

          }catch(errors){
            console.log(errors)
          }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .active{
     color: rgb(255, 72, 47);
  }
</style>